import { render } from "./EmailAttachments.vue?vue&type=template&id=34149d7f&scoped=true"
import script from "./EmailAttachments.vue?vue&type=script&lang=js"
export * from "./EmailAttachments.vue?vue&type=script&lang=js"

import "./EmailAttachments.vue?vue&type=style&index=0&id=34149d7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34149d7f"]])

export default __exports__